import moment from "moment"

export const turnDateIntoStrWithoutTimezone = (date?: Date | '' | null): string => {
  if (!date) {
    return ''
  }
  try {
    const userTimezoneOffset = date.getTimezoneOffset() * 60000
    const dateObj = new Date(date.getTime() - userTimezoneOffset)
    return dateObj.toISOString().split('T')[0]
  } catch (e: any) {
    console.log('ERROR - unable to format date')
    console.log(`input value: ${date}`)
    console.log(e)
    console.log(e.message)
    return ''
  }
}

export const formatDateAndTimeForDisplaying = (dateAndTimeValue?: string | null) => {
  if (!dateAndTimeValue) {
    return ''
  }
  try {
    const formattedDate = moment(new Date(dateAndTimeValue)).format('MMMM Do YYYY, h:mm:ss a')
    return formattedDate
  } catch (e: any) {
    console.log('ERROR - unable to format date and time')
    console.log(`input value: ${dateAndTimeValue}`)
    console.log(e)
    console.log(e.message)
    return dateAndTimeValue
  }
}
